const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  DATABASE_NAME: 'restaurant-app-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurants',
};

export default CONFIG;
